import {
  GET_ALL_PRODUCT_CHANNELS_RESPONSE_SUCCESS,
  GET_ALL_PRODUCT_CHANNELS,
} from "./actionTypes"

export const getAllProductChannels = () => {
  return {
    type: GET_ALL_PRODUCT_CHANNELS,
  }
}
export const getAllProductChannelsResponseSuccess = payload => ({
  type: GET_ALL_PRODUCT_CHANNELS_RESPONSE_SUCCESS,
  payload: payload,
})
